import React from 'react'
import { useNavigate } from 'react-router-dom'

import { CCard, CCardBody, CCardGroup, CCol, CContainer, CRow, CButton } from '@coreui/react'
import { HeaderComponent } from './HeaderComponent'

export const MensajeComponent = ({ title, message, buttonHandler }) => {
  return (
    <div className="min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <HeaderComponent title={title} />
                  {message && (
                    <div className="text-start">
                      <p className="mb-2">{message}</p>
                    </div>
                  )}
                  <CRow>
                    <CCol>
                      <div className="d-grid gap-2">
                        <CButton color="primary" className="px-4" onClick={buttonHandler}>
                          Volver
                        </CButton>
                      </div>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export const ProcesandoPagoPage = () => {
  const navigate = useNavigate()

  const buttonHandler = () => {
    navigate('/seleccionar-cuentas')
  }

  return (
    <MensajeComponent
      title="Procesando pago"
      message={
        <>
          <p>Hemos recibido tu solicitud y la confirmación puede tardar unos minutos.</p>
          <p>Si el pago se confirma, recibirás un correo con el comprobante.</p>
          <p>
            Si no lo encuentras en tu bandeja de entrada, revisa también la carpeta de spam o correo
            no deseado.
          </p>
          <p>En caso de no recibir el comprobante, por favor contáctanos para revisar tu pago.</p>
        </>
      }
      buttonHandler={buttonHandler}
    />
  )
}

export const PagoFallidoPage = () => {
  const navigate = useNavigate()

  const buttonHandler = () => {
    navigate('/seleccionar-cuentas')
  }

  return <MensajeComponent title="Pago fallido" buttonHandler={buttonHandler} />
}
